import { render, staticRenderFns } from "./ConfigGrupos.vue?vue&type=template&id=496afac0&scoped=true&"
import script from "./ConfigGrupos.vue?vue&type=script&lang=js&"
export * from "./ConfigGrupos.vue?vue&type=script&lang=js&"
import style0 from "./ConfigGrupos.vue?vue&type=style&index=0&id=496afac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496afac0",
  null
  
)

export default component.exports